import MachineryList from "./MachineryList";
export * from "./MachineryList";
export default MachineryList;